(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"capa_atlas_1", frames: [[559,502,1141,207],[0,0,557,1000],[559,0,793,500]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_155 = function() {
	this.initialize(ss["capa_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.fachada_arte = function() {
	this.initialize(ss["capa_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.Nuvem1 = function() {
	this.initialize(ss["capa_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.txtLogo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.CachedBmp_155();
	this.instance.setTransform(0,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.txtLogo, new cjs.Rectangle(0,0,570.5,103.5), null);


(lib.Interpolação7 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#C38A66").beginStroke().moveTo(-482.5,500).lineTo(-482.5,-500).lineTo(482.5,-500).lineTo(482.5,500).closePath();
	this.shape.setTransform(482.5,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-500,965,1000);


(lib.Interpolação3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2
	this.instance = new lib.fachada_arte();
	this.instance.setTransform(-410,-436,0.7795,0.7795);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEEFE7").beginStroke().moveTo(-88.3,-116.1).lineTo(-80.5,-118.3).lineTo(-82.8,-132.7).lineTo(-47.2,-158.3).lineTo(-47.2,-167.2).lineTo(16.1,-222.7).lineTo(16.1,-209.4).lineTo(26.1,-183.8).lineTo(62.8,-115).lineTo(62.8,-102.7).lineTo(88.3,-61.6).lineTo(85,221.6).lineTo(-83.9,222.7).closePath();
	this.shape.setTransform(-180.475,-181.575);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-410,-436,434.2,779.5);


(lib.Interpolação1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["rgba(254,239,231,0)","#FEEFE7"],[0.008,1],-18.6,-515.9,-18.6,-295.5).beginStroke().moveTo(-469.5,547.2).lineTo(-469.5,-547.2).lineTo(469.5,-547.2).lineTo(469.5,547.2).closePath();
	this.shape.setTransform(0,0.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-469.4,-547.1,938.9,1094.3000000000002);


(lib.flor = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEEFE7").beginStroke().moveTo(9.7,35).curveTo(9.3,34.7,9.6,34.3).curveTo(9.7,33.9,10.4,34).curveTo(12.9,34.1,12.7,31.5).curveTo(12.6,28.9,10,29).curveTo(9.4,29,9.1,28.6).curveTo(8.9,28.2,9.3,27.7).curveTo(14.1,22.4,19.4,24.8).curveTo(24.1,26.9,23.9,31.8).curveTo(23.6,36.1,19.8,37.2).curveTo(18.8,37.6,17.6,37.6).curveTo(14.2,37.6,9.7,35).closePath().moveTo(-19.9,37.2).curveTo(-23.6,36.1,-23.8,31.8).curveTo(-24.1,26.9,-19.3,24.8).curveTo(-14.2,22.4,-9.2,27.7).curveTo(-9,28.2,-9.2,28.6).curveTo(-9.4,29,-10,29).curveTo(-12.5,28.9,-12.7,31.5).curveTo(-12.8,34.1,-10.3,34).curveTo(-9.8,33.9,-9.5,34.3).curveTo(-9.3,34.7,-9.7,35).curveTo(-14.2,37.6,-17.6,37.6).curveTo(-18.8,37.6,-19.9,37.2).closePath().moveTo(6,27.9).curveTo(5.6,27.6,5.9,27).curveTo(8.2,22,12.9,17.4).curveTo(17.3,13,24.5,12.6).curveTo(32.9,12.2,33.4,18.5).curveTo(33.7,22,31.3,23.9).curveTo(28.9,25.9,25.6,24.6).curveTo(21.5,22.5,19.4,21.9).curveTo(16,20.9,12.9,22.4).curveTo(8.7,24.8,6.6,27.7).curveTo(6.5,27.8,6.5,27.9).curveTo(6.4,27.9,6.4,27.9).curveTo(6.3,28,6.3,28).curveTo(6.2,28,6.2,28).lineTo(6,27.9).closePath().moveTo(-6.6,27.7).curveTo(-8.7,24.8,-12.9,22.4).curveTo(-16,20.9,-19.4,21.9).lineTo(-25.6,24.6).curveTo(-28.9,25.9,-31.3,23.9).curveTo(-33.7,22,-33.5,18.5).curveTo(-32.8,12.2,-24.5,12.6).curveTo(-17.3,13,-12.9,17.4).curveTo(-8.3,21.9,-5.8,27).curveTo(-5.6,27.6,-5.9,27.9).lineTo(-6.2,28).curveTo(-6.2,28,-6.3,28).curveTo(-6.3,28,-6.4,27.9).curveTo(-6.4,27.9,-6.5,27.9).curveTo(-6.5,27.8,-6.6,27.7).closePath().moveTo(-0.6,25.3).curveTo(-0.5,22.2,-1.6,5.3).lineTo(-2.3,-0.4).curveTo(-2.8,-3.6,-3.6,-7.2).lineTo(-5.7,-14.9).curveTo(-7.1,-20.7,-7.5,-24.8).curveTo(-8.6,-37.2,-0.2,-37.6).curveTo(8.6,-37.3,7.6,-25).curveTo(7.1,-19.9,3.4,-7.2).curveTo(2.3,-3.3,1.8,-0.3).lineTo(1.3,5.3).curveTo(0.7,15.2,0.4,25.3).curveTo(0.2,27.8,-0.2,27.8).curveTo(-0.7,27.8,-0.6,25.3).closePath().moveTo(3.7,27.6).curveTo(3.3,27.5,3.6,26.4).curveTo(6.7,16.3,11,9.5).curveTo(16.1,1.5,24.2,-3.8).curveTo(27.4,-5.7,30.1,-5.3).curveTo(32.6,-5,33.9,-2.7).curveTo(36.4,1.3,34.7,4.6).curveTo(31,10,24.5,9.2).curveTo(19.8,9,15.6,11.8).curveTo(12.4,14,8.8,18.5).curveTo(5.8,23.1,4.4,26.6).curveTo(4.1,27.6,3.8,27.6).lineTo(3.7,27.6).closePath().moveTo(-4.5,26.6).curveTo(-5.7,23.1,-8.9,18.5).curveTo(-12.3,14,-15.6,11.8).curveTo(-19.8,9,-24.5,9.2).curveTo(-31,10,-34.7,4.6).curveTo(-36.4,1.3,-33.9,-2.7).curveTo(-32.5,-5,-30,-5.3).curveTo(-27.4,-5.7,-24.3,-3.8).curveTo(-16.1,1.5,-11,9.5).curveTo(-6.6,16.3,-3.6,26.4).curveTo(-3.3,27.5,-3.7,27.6).lineTo(-3.8,27.6).curveTo(-4.1,27.6,-4.5,26.6).closePath().moveTo(3.3,19.9).curveTo(4.3,5,6.5,-3.7).curveTo(10.2,-18.5,18.1,-24.1).curveTo(20.1,-25.4,22.5,-25.2).curveTo(24.7,-25,26.6,-23.4).curveTo(28.7,-21.6,28.9,-18.9).curveTo(29.3,-16.1,27.4,-13.4).curveTo(25.9,-11.2,23.1,-8.5).curveTo(20.9,-6.4,16.2,-2.6).curveTo(7.2,5.8,4.3,19.9).curveTo(4,20.8,3.7,20.8).curveTo(3.4,20.8,3.3,19.9).closePath().moveTo(-4.3,19.9).curveTo(-7,5.9,-16.2,-2.6).curveTo(-20.8,-6.4,-23,-8.5).curveTo(-25.8,-11.2,-27.3,-13.4).curveTo(-29.3,-16,-29,-18.9).curveTo(-28.7,-21.6,-26.6,-23.4).curveTo(-24.7,-25,-22.5,-25.2).curveTo(-20.1,-25.4,-18.1,-24.1).curveTo(-10.1,-18.5,-6.5,-3.7).curveTo(-4.3,5,-3.3,19.9).curveTo(-3.4,20.8,-3.8,20.8).curveTo(-4.1,20.8,-4.3,19.9).closePath();
	this.shape.setTransform(85.3362,90.5531,2.4112,2.4112);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.flor, new cjs.Rectangle(0,0,170.7,181.1), null);


(lib.cloud1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.Nuvem1();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.cloud1, new cjs.Rectangle(0,0,793,500), null);


(lib.nuvem1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2
	this.instance = new lib.cloud1();
	this.instance.setTransform(385.1,19.1,1.0574,1.3932,0,0,180,396.4,250);
	this.instance.alpha = 0.3594;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(514).to({_off:false},0).to({scaleX:0.759,scaleY:1,x:3184,y:27.3,alpha:0},2384).wait(1));

	// Camada_1
	this.instance_1 = new lib.cloud1();
	this.instance_1.setTransform(396.5,250,1,1,0,0,0,396.5,250);
	this.instance_1.alpha = 0.5195;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({x:3416,alpha:0},1883).to({_off:true},1).wait(1015));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-34.3,-329.2,3846.8,829.2);


(lib.content_frame_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {start:1,complete:41};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 *  Play the animate.
		 */
		this.gotoAndPlay('start');
	}
	this.frame_40 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		const AllTapParent = window.parent.AllTap;
		
		AllTapParent.emit('animate_end', {complete: true, object: this});
	}
	this.frame_64 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		const AllTapParent = window.parent.AllTap;
		
		AllTapParent.emit('animate_end', {end: true});
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(40).call(this.frame_40).wait(24).call(this.frame_64).wait(1));

	// Camada_4
	this.instance = new lib.txtLogo();
	this.instance.setTransform(1442.5,602.9,1,1,0,0,0,285.3,51.7);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(32).to({_off:false},0).to({alpha:1},8).wait(9).to({alpha:0},9).to({_off:true},1).wait(6));

	// Camada_10
	this.instance_1 = new lib.flor();
	this.instance_1.setTransform(1442.1,478.85,0.3153,0.3153,0,0,0,85.3,90.5);
	this.instance_1.alpha = 0.2305;
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(23).to({_off:false},0).to({regX:85.4,scaleX:1,scaleY:1,x:1442.15,y:435.55,alpha:1},9,cjs.Ease.get(1)).wait(17).to({regX:85.3,scaleX:0.3153,scaleY:0.3153,x:1442.1,y:478.85,alpha:0},9).to({_off:true},1).wait(6));

	// Camada_9
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,10.1).lineTo(0,-10.1);
	this.shape.setTransform(1442.5,8.825);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-25).lineTo(0,25);
	this.shape_1.setTransform(1442.5,23.75);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-39.9).lineTo(0,39.9);
	this.shape_2.setTransform(1442.5,38.65);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-54.8).lineTo(0,54.8);
	this.shape_3.setTransform(1442.5,53.575);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-69.8).lineTo(0,69.8);
	this.shape_4.setTransform(1442.5,68.5);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-84.7).lineTo(0,84.7);
	this.shape_5.setTransform(1442.5,83.4);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-99.6).lineTo(0,99.6);
	this.shape_6.setTransform(1442.5,98.325);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-114.5).lineTo(0,114.5);
	this.shape_7.setTransform(1442.5,113.25);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-129.4).lineTo(0,129.4);
	this.shape_8.setTransform(1442.5,128.15);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,144.3).lineTo(0,-144.3);
	this.shape_9.setTransform(1442.5,143.075);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-127.7).lineTo(0,127.7);
	this.shape_10.setTransform(1442.5,126.45);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-111.1).lineTo(0,111.1);
	this.shape_11.setTransform(1442.5,109.85);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-94.5).lineTo(0,94.5);
	this.shape_12.setTransform(1442.5,93.225);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-77.9).lineTo(0,77.9);
	this.shape_13.setTransform(1442.5,76.625);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-61.2).lineTo(0,61.2);
	this.shape_14.setTransform(1442.5,60);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-44.6).lineTo(0,44.6);
	this.shape_15.setTransform(1442.5,43.375);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-28).lineTo(0,28);
	this.shape_16.setTransform(1442.5,26.775);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,11.4).lineTo(0,-11.4);
	this.shape_17.setTransform(1442.5,10.15);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape}]},14).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[{t:this.shape_5}]},1).to({state:[{t:this.shape_6}]},1).to({state:[{t:this.shape_7}]},1).to({state:[{t:this.shape_8}]},1).to({state:[{t:this.shape_9}]},1).to({state:[{t:this.shape_9}]},18).to({state:[{t:this.shape_10}]},1).to({state:[{t:this.shape_11}]},1).to({state:[{t:this.shape_12}]},1).to({state:[{t:this.shape_13}]},1).to({state:[{t:this.shape_14}]},1).to({state:[{t:this.shape_15}]},1).to({state:[{t:this.shape_16}]},1).to({state:[{t:this.shape_17}]},1).to({state:[]},1).wait(15));

	// Camada_8
	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,15.2).lineTo(0,-15.2);
	this.shape_18.setTransform(1442.5,985.325);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-29.3).lineTo(0,29.3);
	this.shape_19.setTransform(1442.5,971.225);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-43.4).lineTo(0,43.4);
	this.shape_20.setTransform(1442.5,957.125);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-57.5).lineTo(0,57.5);
	this.shape_21.setTransform(1442.5,943.025);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-71.6).lineTo(0,71.6);
	this.shape_22.setTransform(1442.5,928.925);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-85.7).lineTo(0,85.7);
	this.shape_23.setTransform(1442.5,914.8);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-99.8).lineTo(0,99.8);
	this.shape_24.setTransform(1442.5,900.7);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-113.9).lineTo(0,113.9);
	this.shape_25.setTransform(1442.5,886.6);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-128).lineTo(0,128);
	this.shape_26.setTransform(1442.5,872.5);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,142.1).lineTo(0,-142.1);
	this.shape_27.setTransform(1442.5,858.4);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-126.4).lineTo(0,126.4);
	this.shape_28.setTransform(1442.5,874.1);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-110.7).lineTo(0,110.7);
	this.shape_29.setTransform(1442.5,889.8);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-95).lineTo(0,95);
	this.shape_30.setTransform(1442.5,905.475);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-79.3).lineTo(0,79.3);
	this.shape_31.setTransform(1442.5,921.175);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-63.6).lineTo(0,63.6);
	this.shape_32.setTransform(1442.5,936.875);

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-47.9).lineTo(0,47.9);
	this.shape_33.setTransform(1442.5,952.575);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,-32.2).lineTo(0,32.2);
	this.shape_34.setTransform(1442.5,968.25);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,0,4).moveTo(0,16.5).lineTo(0,-16.6);
	this.shape_35.setTransform(1442.5,983.95);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_18}]},14).to({state:[{t:this.shape_19}]},1).to({state:[{t:this.shape_20}]},1).to({state:[{t:this.shape_21}]},1).to({state:[{t:this.shape_22}]},1).to({state:[{t:this.shape_23}]},1).to({state:[{t:this.shape_24}]},1).to({state:[{t:this.shape_25}]},1).to({state:[{t:this.shape_26}]},1).to({state:[{t:this.shape_27}]},1).to({state:[{t:this.shape_27}]},18).to({state:[{t:this.shape_28}]},1).to({state:[{t:this.shape_29}]},1).to({state:[{t:this.shape_30}]},1).to({state:[{t:this.shape_31}]},1).to({state:[{t:this.shape_32}]},1).to({state:[{t:this.shape_33}]},1).to({state:[{t:this.shape_34}]},1).to({state:[{t:this.shape_35}]},1).to({state:[]},1).wait(15));

	// TampoMarrom
	this.instance_2 = new lib.Interpolação7("synched",0);
	this.instance_2.setTransform(960,-504.4);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1).to({_off:false},0).to({y:500},8,cjs.Ease.get(1)).wait(47).to({startPosition:0},0).to({y:-526},8).wait(1));

	// TampoFachada
	this.instance_3 = new lib.Interpolação1("synched",0);
	this.instance_3.setTransform(478.15,648.85,1.0184,1.1856,180,0,0,-0.1,-0.1);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1).to({_off:false},0).to({y:-647.15},13).to({_off:true},1).wait(41).to({_off:false,regX:-0.2,scaleX:0.8979,x:534.85,y:-674.15},0).to({y:662.35},8).wait(1));

	// fachada
	this.instance_4 = new lib.Interpolação3("synched",0);
	this.instance_4.setTransform(726.8,585.75,1.3522,1.3522,0,0,0,0.1,0.1);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1).to({_off:false},0).wait(64));

	// makNuvem (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_1 = new cjs.Graphics().moveTo(-450.5,500).lineTo(-450.5,-500).lineTo(450.5,-500).lineTo(450.5,500).closePath();

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:null,x:0,y:0}).wait(1).to({graphics:mask_graphics_1,x:509.475,y:500}).wait(64));

	// Nuvens
	this.instance_5 = new lib.nuvem1();
	this.instance_5.setTransform(-428.1,244.2,0.6549,0.5421);
	this.instance_5.alpha = 0.8711;
	this.instance_5._off = true;

	var maskedShapeInstanceList = [this.instance_5];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(1).to({_off:false},0).wait(64));

	// Size
	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-960,500).lineTo(-960,-500).lineTo(960,-500).lineTo(960,500).closePath();
	this.shape_36.setTransform(960,500);

	this.timeline.addTween(cjs.Tween.get(this.shape_36).wait(65));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-1323,1925,2634);


// stage content:
(lib.capa = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {frame01:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0,1];
	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		const loadController = () => {
		    if (typeof (window.parent.AllTap) !== 'undefined') {
		        /**
		         *
		         * Class reference.
		         */
		        const
		            AllTapParent = window.parent.AllTap,
		            name_current = 'capa';
		
		        /**
		         *
		         *  @param object
		         *  Set "this", object of canvas CreateJs.
		         */
		        AllTapParent.setState({...AllTapParent.state, [`_this_${name_current}`]: this});
			
				this.gotoAndStop('frame01');
		
		        createjs.Ticker.removeEventListener('tick', loadController);
		    }
		};
		
		createjs.Ticker.addEventListener('tick', loadController);
	}
	this.frame_1 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1));

	// ContentFrame
	this.instance = new lib.content_frame_01();
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1000);
// library properties:
lib.properties = {
	id: '39C810D71620AD44875DF2CE9B2FBD23',
	width: 1920,
	height: 1000,
	fps: 30,
	color: "#FFFFFF",
	opacity: 0.00,
	manifest: [
		{src:"./images/capa_atlas_1.png", id:"capa_atlas_1"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['39C810D71620AD44875DF2CE9B2FBD23'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
